export const getDailyWorkoutTrainingPlanId = (state: any) => {
  if (state.dailyWorkout && state.dailyWorkout.dailyWorkout) {
    return state.dailyWorkout.dailyWorkout.id;
  }
  return null;
};
export const hasDailyWorkout = (state: any) => !!state.dailyWorkout.dailyWorkout;
